import React, { Component } from 'react';
import styled from 'styled-components';
import { PrestoAppTheme } from 'presto-mini-apps-lib';
import Lottie from 'lottie-react-web';
import { PreloaderPresto } from '../../assets/images';


class Preloader extends Component {
    
    render() {
        const { 
            title,
            message, 
        } = this.props;

        return (
            <PreloaderWrapper className="preloader">
                <div className="content">
                    <div className="logo">
                        <div className="logo-animation">
                            <Lottie
                                options={{
                                    animationData: PreloaderPresto
                                }}
                            />
                        </div>
                    </div>
                    <div className="message">
                        <h3 className="title">{title}</h3>
                        <div className="text" dangerouslySetInnerHTML={{__html: message}} />
                    </div>
                </div>
            </PreloaderWrapper>
        );
    }
}

export default Preloader;


const PreloaderWrapper = styled.div`
    // display: none;
    display: flex;
    ${PrestoAppTheme.layout.absoluteFullStyle};
    background-color: rgba(${PrestoAppTheme.colors.whiteRGB}, .95);
    justify-content: center;
    align-items: center;
    z-index: 1;

    &.show {
        display: flex;
    }

    & .content {
        position: relative;
        width: 250px;
        margin: 0 auto;
        text-align: center;
        
        & .logo {
            position: relative;
            height: 90px;
            width: 90px;
            margin: 0 auto;
            overflow: hidden;

            & .logo-animation {
                position: absolute;
                top: -80px;
                left: -80px;
                height: 250px;
                width: 250px;
            }
        }

        & .message {
            width: 100%;
            margin: ${PrestoAppTheme.layout.largeGap} auto;
            font-weight: 400;
            text-align: center;
            color: ${PrestoAppTheme.colors.prestoRed}
    
            & h3.title {
                margin: 0 0 ${PrestoAppTheme.layout.smallGap};
                font-size: 1.1875rem; // 19px
                font-weight: 400;
            }
    
            & > .text {
                // color: ${PrestoAppTheme.colors.baseGreyDark};
            }
        }
    }
`;